module.exports = __webpack_public_path__ + "static/media/globoserv.c13bc538.png";